import z from 'zod';

// Live-view visibility options enum
export const liveViewOption = z.enum(['always_on', 'always_off', 'default_on', 'default_off']);
export type LiveViewOption = z.infer<typeof liveViewOption>;

// Model for DesklyConnect settings
export const desklyConnectSettings = z.object({
    active: z.boolean(),
    autoBooking: z.boolean(),
    hotDeskingDisabledForAnyLocation: z.boolean(),
    liveViewVisibility: liveViewOption,
});

export type DesklyConnectSettings = z.infer<typeof desklyConnectSettings>;

// Form model for updating DesklyConnect settings
export const desklyConnectForm = z.object({
    active: z.boolean(),
    autoBooking: z.boolean(),
    liveViewVisibility: liveViewOption,
});

export type DesklyConnectForm = z.infer<typeof desklyConnectForm>;
